<template>
  <div class="SecurityInfo">
    <div id="PDFIframe"></div>
    <div style="background-color: white; padding: 20px">
      <van-field
        label-width="150"
        error-message-align="right"
        input-align="right"
        v-model="FindFormApplyDetailData.FormApply.fmap03"
        name="表单名称"
        readonly
        colon
        label="表单名称"
        placeholder="请输入表单名称"
      />
      <van-form ref="submit" @submit="onSubmit">
        <div v-for="(item, index) in tempFields" :key="item.fafd01">
          <van-field
            input-align="right"
            v-if="item.fafd03 == 1"
            label-width="150"
            v-model="item.fafd06"
            :label="item.fafd05"
            colon
            name="fmfd06"
            placeholder="请选择输入内容"
          />
          <van-field
            input-align="right"
            v-if="item.fafd03 == 4"
            readonly
            label-width="150"
            v-model="item.fafd06"
            :label="item.fafd05"
            colon
            name="fmfd06"
            placeholder="请选择输入内容"
          />
          <!-- 7填表人员 -->
          <van-field
            input-align="right"
            v-if="item.fafd03 == 7"
            readonly
            label-width="150"
            v-model="item.fafd06"
            :label="item.fafd05"
            colon
            name="fmfd06"
            placeholder="请选择输入内容"
          />
          <!--  8提交时间-->

          <template v-if="item.fafd03 == 8">
            <van-cell
              :title="item.fafd05"
              :value="item.fafd06"
              @click="
                timeShow = true;
                items = item;
              "
            />
          </template>
          <!-- <van-cell
            v-if="item.fafd03 == 2"
            :title="item.fafd05"
            :value="item.fafd06"
          /> -->
          <!-- popupShow = true; -->
          <!-- 5金额 -->
          <van-cell :title="item.fafd06" class="flexLR" v-if="item.fafd03 == 5">
            <template slot="default">
              <van-stepper
                default-value="0"
                input-width="80px"
                step="0.1"
                v-model="item.fafd05"
                :decimal-length="2"
              />
            </template>
          </van-cell>
          <van-cell :title="item.fafd06" class="flexLR" v-if="item.fafd03 == 6">
            <template slot="default">
              <van-radio-group
                style="float: right"
                v-model="item.fafd05"
                direction="horizontal"
              >
                <van-radio name="是">是</van-radio>
                <van-radio name="否">否</van-radio>
              </van-radio-group>
            </template>
          </van-cell>
          <!-- 选择集选择视点 -->
          <van-field
            input-align="right"
            :label="item.fafd06"
            v-if="item.fafd03 == 10 || item.fafd03 == 11"
            :value="
              item.fafd05 != ''
                ? '已上传'
                : item.fafd05 == 10
                ? '请选择视点'
                : '请选择选择集'
            "
            readonly
            @click="changeModelOrView(item, 1)"
          >
          </van-field>
          <van-cell
            :title="item.fafd05"
            class="flexLR"
            v-if="
              item.fafd03 == 12 ||
              item.fafd03 == 3 ||
              item.fafd03 == 2 ||
              item.fafd03 == 9
            "
          >
            <template slot="default">
              <div class="flexLR" style="justify-content: end">
                <div class="flexLR" v-if="item.fafd03 != 2">
                  <span style="margin-right: 8px; color: rgb(25, 137, 250)">{{
                    item.fafd06 ? "已上传" : ""
                  }}</span>
                  <van-button
                    native-type="button"
                    size="mini"
                    icon="plus"
                    @click.stop="openUpdateFile(item.fafd01)"
                  >
                    上传文件
                  </van-button>
                  <input
                    type="file"
                    :ref="item.fafd01"
                    name="Files"
                    style="display: none"
                    @change="clickUpload($event, item)"
                  />
                  <!-- :accept="item.fafd03 != 4 ? 'image/png' : 'video/mp4'" -->
                </div>
                <div v-else style="width: 100%" class="flexLR">
                  <van-button
                    style="width: 100%"
                    native-type="button"
                    size="mini"
                    icon="service-o"
                    @click.stop="
                      items = item;
                      play(item);
                    "
                  >
                    {{ item.fafd06 == "" ? "录音" : "播放录音" }}
                  </van-button>
                  <van-button
                    style="width: 100%"
                    type="info"
                    @click="item.fafd06 = ''"
                    native-type="button"
                    icon="revoke"
                    size="mini"
                    v-if="item.fafd06 != ''&&item.fafd06!=null"
                    >重录
                  </van-button>
                </div>
              </div>
            </template>
          </van-cell>
        </div>

        <audio ref="LogAudioPlayer" style="display: none; width: 100%"></audio>

        <van-uploader
          ref="chooseFile"
          v-if="items.fafd03"
          :accept="items.fafd03 == 4 ? 'video/*' : 'image/*'"
          style="display: none; width: 100%"
          v-model="fileList"
          :after-read="fileChange"
          :multiple="true"
        >
          <van-button
            size="mini"
            native-type="button"
            icon="plus"
            type="primary"
            >上传文件</van-button
          >
        </van-uploader>

        <van-calendar
          v-model="timeShow"
          @confirm="(val) => TimeonConfirm(val, items)"
        />

        <van-popup
          style="padding: 20px"
          v-model="popupShow"
          round
          position="bottom"
          :style="{ height: '50%' }"
        >
          <div
            class="flexcolumn"
            style="
              height: 100%;
              justify-content: space-between;
              align-items: start;
            "
          >
            <van-checkbox-group v-model="userList">
              <van-checkbox
                style="margin: 10px 0"
                v-for="(checkboxItem, index) in checkboxItemList"
                :key="checkboxItem.user01"
                :name="checkboxItem.user04"
                >{{ checkboxItem.user04 }}
              </van-checkbox>
            </van-checkbox-group>
            <div class="btn-group flexLR" style="width: 100%">
              <van-button
                style="width: 49%"
                native-type="button"
                ref="regionResetBtn"
                round
                type="warning"
                size="small"
                @click="userList = []"
                class="btn-group-button"
              >
                重置</van-button
              >
              <van-button
                style="width: 49%"
                native-type="button"
                @click="addUser"
                round
                type="info"
                size="small"
                class="btn-group-button"
                >确认
              </van-button>
            </div>
          </div>
        </van-popup>
      </van-form>
      <div style="padding: 25px 16px" class="flexLR">
        <van-button
          block
          type="info"
          v-if="FormApplyState === 1"
          @click.stop="$refs.submit.submit()"
          >同意</van-button
        >
        <van-button
          style="margin: 0 5px"
          block
          type="danger"
          v-if="FormApplyState === 1"
          @click.stop="showRefuse = true"
          >拒绝</van-button
        >
        <van-dialog
          v-model="showRefuse"
          title="拒绝内容"
          show-cancel-button
          @confirm="RefuseMsg"
        >
          <van-field
            v-model="inputMessage"
            rows="2"
            autosize
            type="textarea"
            maxlength="50"
            placeholder="请输入内容"
            show-word-limit
          />
        </van-dialog>
        <van-button
          block
          v-if="processStep.fmad10 != null ? true : false"
          type="warning"
          @click.stop="showReject = true"
          >驳回</van-button
        >
        <van-dialog
          v-model="showReject"
          title="驳回内容"
          show-cancel-button
          @confirm="RejectMsg"
        >
          <van-field
            v-model="rejectMessage"
            rows="2"
            autosize
            type="textarea"
            maxlength="50"
            placeholder="请输入内容"
            show-word-limit
          />
        </van-dialog>
      </div>
    </div>
    <van-popup
      round
      v-model="show"
      style="width: 80%; height: 60%; padding: 20px"
    >
      <div
        style="width: 100%; height: 100%; justify-content: space-between"
        class="flexcolumn"
      >
        <div
          style="height: 95%"
          v-if="
            GetFullFormTempList.filter(
              (el) => el.fmtp01 == AddFormApplyParams.tempId
            ).length
          "
        >
          <iframe
            type="application/pdf"
            :src="
              $store.state.baseUrl +
              GetFullFormTempList.filter(
                (el) => el.fmtp01 == AddFormApplyParams.tempId
              )[0].fmtp05
            "
            width="100%"
            height="100%"
            frameborder="0"
          ></iframe>
        </div>
        <van-button
          style="width: 100%; margin-top: 10px"
          type="info"
          @click="AddFormApply"
          round
          >发布</van-button
        >
      </div>
    </van-popup>
    <Recorderx ref="Recorderx"></Recorderx>
    <van-popup
      v-model="show1"
      round
      position="bottom"
      :style="{ height: '30%' }"
    >
      <div v-if="isLY">
        <div class="wave w1"></div>
        <div class="wave w2"></div>
      </div>
      <div class="flex" style="height: 100%; width: 100%; padding: 40px">
        <div class="flexcolumn">
          <van-icon name="close" size="40" @click="closeLY" />
          重录
        </div>
        <div class="diyButton" @click="startLY">
          {{ isLY ? "录音中..." : "录音" }}
        </div>
        <div class="flexcolumn">
          <van-icon @click="endLY" name="passed" size="40" />
          完成
        </div>
      </div>
    </van-popup>
    <van-loading
      class="loading-bg"
      type="spinner"
      size="24px"
      v-show="httpLoading"
    />
    <!-- 选择集选择视点 -->
    <van-popup
      v-model="modelOrView"
      closeable
      close-icon="close"
      position="bottom"
      :style="{ height: '50%' }"
      round
    >
      <van-tree-select
        :items="lists"
        @click-nav="onNavClick"
        :main-active-index.sync="activeIndex"
      >
        <template slot="content">
          <div v-for="(item, index) in selectOrViewList" :key="index">
            <van-cell :value="item.name" @click="changeRight(item)" />
          </div>
        </template>
      </van-tree-select>
    </van-popup>
  </div>
</template>

<script>
import {
  SubmitTurndown,
  SubmitAudit,
  FindFormApplyDetail,
  GetNetDateTime,
  GetFullFormTemp,
  GetFormAuditFlowList,
  GetOneFormAuditFlow,
  GetOneFormTemp,
  GetProUsersList,
  AddSafeFormApply,
  GetWorkPlaneTree2,
} from "@/api";
import Recorderx from "@/components/Recorderx";
import Pdfh5 from "pdfh5";

export default {
  name: "addSecurity",
  components: { Recorderx },
  data() {
    return {
      FindFormApplyDetailData: {
        FormApply: {
          famp06: "",
          famp07: "",
        },
        FormAuditRecord: [],
        FormApplySafeFields: [],
        FormAuditFlow: [],
      },
      FormApplyState: null,
      list: [],
      GetFullFormTempList: ["杭州", "宁波", "温州", "嘉兴", "湖州"],
      showPicker: false,
      showPicker2: false,
      show: false,
      show1: false,
      isLY: false,
      AddFormApplyParams: {
        name: "",
        tempId: "",
        auditId: "",
        qid: "",
      },
      AuditFlowList: [],
      detailList: [],
      auditName: "",
      formTemplateName: "",
      formTemp: null,
      tempFields: [],
      timeShow: false,
      checkboxItemList: [],
      popupShow: false,
      userList: [],
      items: {},
      fileList: [],
      httpLoading: false,
      processStep: {}, //流程步骤
      showRefuse: false,
      showReject: false,
      inputMessage: "",
      rejectMessage: "",
      newDate: new Date().toLocaleDateString(),
      //选择集，视点---
      selectOrViewList: [],
      addOrEdit: 1,
      fmfdObj: {},
      modelOrView: false,
      zNodes: null,
      activeIndex: 0,
    };
  },
  computed: {
    lists: function () {
      if (this.zNodes == undefined) {
        return [];
      } else {
        let arr = [];
        this.zNodes.forEach((item) => {
          item.text = item.label;
          arr.push(item);
        });
        return arr;
      }
    },
  },
  watch: {
    activeIndex: async function () {
      if (this.lists.length !== 0) {
        let id = this.lists[this.activeIndex].ID;
        let findObj = this.zNodes.find((ele) => ele.ID == id);
        if (findObj.wopl07 !== 1) {
          this.$Toast.fail("只能选择单模");
        } else {
          let res = await FindWorkPlaneModel({ id });
          let modelId = res.Data.modelId;
          let res2 = await GetModelSelectOrViewPoint({
            mid: modelId,
            seachword: "",
            type:
              this.addOrEdit == 1
                ? this.fmfdObj.fmfd04 == 10
                  ? 3
                  : 1
                : this.fmfdObj.fafd03 == 10
                ? 3
                : 1,
            uid: localStorage.id,
          });
          this.selectOrViewList = res2.Data;
        }
        console.log(id, "书类别中的id");
      } else {
        this.selectOrViewList = [];
      }
    },
  },
  methods: {
    // 选择集选择视点
    async changeModelOrView(data, type) {
      this.selectOrViewList = [];
      this.addOrEdit = type;
      this.fmfdObj = data;
      this.modelOrView = true;
      let params = {
        xid: localStorage.getItem("xid"),
        pid: -1,
      };
      let res = await GetWorkPlaneTree2(params);
      this.zNodes = res.Data;
      console.log(this.zNodes);
    },
    onNavClick(index) {
      console.log(index);
    },
    changeRight(data) {
      console.log(data);
      if (data.pic) {
        if (this.addOrEdit == 1) {
          this.fmfdObj.fmfd02 = data.pic;
        } else {
          this.fmfdObj.fafd06 = data.pic;
        }
        this.modelOrView = false;
      } else {
        this.$message.warning("该选择集下无图片");
      }
    },
    openUpdateFile(id) {
      this.$refs[id][0].click();
    },

    RefuseMsg() {
      let fd = new FormData();
      for (
        var i = 0, length = this.FindFormApplyDetailData.FormApplyFields.length;
        i < length;
        i++
      ) {
        var ele = this.FindFormApplyDetailData.FormApplyFields[i];
        fd.append(ele.fafd05, ele.fafd06);
      }
      fd.append("content", this.inputMessage);
      fd.append("qid", this.$store.state.qid);
      fd.append("id", this.FindFormApplyDetailData.FormApply.fmap01);
      fd.append("type", 2);
      SubmitAudit(fd).then((res) => {
        if (res.Code > 0) {
          this.$Toast("拒绝成功");
          this.showRefuse = false;
          // this.GetFormApply();
          this.$router.go(-1);
        }
      });
    },
    RejectMsg() {
      let fd = new FormData();
      for (
        var i = 0, length = this.FindFormApplyDetailData.FormApplyFields.length;
        i < length;
        i++
      ) {
        var ele = this.FindFormApplyDetailData.FormApplyFields[i];
        fd.append(ele.fafd05, ele.fafd06);
      }
      fd.append("content", this.rejectMessage);
      fd.append("qid", this.$store.state.qid);
      fd.append("id", this.FindFormApplyDetailData.FormApply.fmap01);
      SubmitTurndown(fd).then((res) => {
        if (res.Code > 0) {
          this.$Toast("驳回成功");
          this.showReject = false;
          // this.GetFormApply();
          this.$router.go(-1);
        }
      });
    },
    // GetNetDateTime() {
    //   GetNetDateTime().then((res) => {
    //     this.newDate = res.Data;
    //   });
    // },
    clickUpload(e, item) {
      item.fafd06 = e.target.files[0];
      this.items = item;
    },
    fileChange(file) {
      this.items.fafd06 = file.file;
    },
    addUser() {
      this.items.fafd06 = this.userList.toString().substr(1);
      this.userList = [];
      this.popupShow = false;
    },
    GetProUsersList() {
      let params = {
        seachword: "",
        id: this.$store.state.pid,
        cid: this.$store.state.qid,
        bid: "null",
        pageIndex: 1,
        pageSize: 999999,
      };
      GetProUsersList({ params }).then((res) => {
        this.checkboxItemList = res.Data.list;
      });
    },
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    TimeonConfirm(date, item) {
      item.fafd06 = this.formatDate(date);
      this.timeShow = false;
    },
    GetFormAuditFlowList() {
      let params = {
        xid: this.$store.state.pid,
        searchword: "",
        pageIndex: 1,
        pageSize: 99999,
        type: 2,
      };
      GetFormAuditFlowList({ params }).then((res) => {
        this.AuditFlowList = res.Data.list;
        this.AddFormApplyParams.qid = this.$store.state.qid;
        if (res.Data.list.length) {
          this.AddFormApplyParams.auditId = this.AuditFlowList[0].fafl01;
          this.auditName = this.AuditFlowList[0].fafl03;
          this.GetOneFormAuditFlow(this.AddFormApplyParams.auditId);
        }
      });
    },
    GetOneFormAuditFlow(id) {
      let params = { id };
      GetOneFormAuditFlow({ params }).then((res) => {
        this.detailList = res.Data.detailList;
      });
    },
    AddFormApply() {
      let fd = new FormData();
      for (var key in this.AddFormApplyParams) {
        fd.append(key, this.AddFormApplyParams[key]);
      }
      this.tempFields.forEach((ele) => {
        fd.append(ele.fmfd06, ele.fafd06);
      });
      fd.append("famp15", 2);
      AddSafeFormApply(fd).then((res) => {
        if (res.Code) {
          this.$Toast("添加成功");
          Object.assign(this.$data, this.$options.data());
        }
      });
    },
    GetFullFormTemp() {
      GetFullFormTemp({
        params: {
          xid: this.$store.state.pid,
          type: 2,
        },
      }).then((res) => {
        this.GetFullFormTempList = res.Data;
        this.formTemp = res.Data[0];
        this.AddFormApplyParams.tempId = res.Data[0].fmtp01;
      });
    },
    endLY() {
      this.$refs.Recorderx.recStop().then((blob) => {
        this.items.fafd06 = blob || "";
        this.isLY = false;
        this.show1 = false;
      });
    },
    play() {
      let _this = this;
      if (this.items.fafd06 == "") {
        this.show1 = true;
      } else {
        var audio = this.$refs.LogAudioPlayer;
        audio.controls = true;
        if (!(audio.ended || audio.paused)) {
          audio.pause();
        }
        audio.onerror = function (e) {
          _this.$Toast.fail("播放失败");
        };
        audio.src = (window.URL || webkitURL).createObjectURL(
          this.items.fafd06
        );
        audio.play();
      }
    },
    startLY() {
      this.$refs.Recorderx.recOpen().then((res) => {
        this.isLY = res;
      });
    },
    closeLY() {
      this.isLY = false;
      this.$refs.Recorderx.recClose();
    },
    onConfirm(value) {
      this.formTemplateName = value.fmtp03;
      this.AddFormApplyParams.tempId = value.fmtp01;
      this.GetOneFormTemp(value.fmtp01);
      this.showPicker = false;
    },
    onConfirm2(value) {
      this.GetOneFormAuditFlow(value.fafl01);
    },
    onSubmit(errorInfo) {
      this.SubmitAudit();
    },
    SubmitAudit() {
      this.httpLoading = true;
      let fd = new FormData();
      for (
        var i = 0, length = this.FindFormApplyDetailData.FormApplyFields.length;
        i < length;
        i++
      ) {
        var ele = this.FindFormApplyDetailData.FormApplyFields[i];
        // if (
        //   (ele.fafd03 == 12 || ele.fafd03 == 3 || ele.fafd03 == 2) &&
        //   ele.fafd06 != null
        // ) {
        //   if (ele.fafd06.name) {
        //     var ext = ele.fafd06.name
        //       .substr(ele.fafd06.name.lastIndexOf("."))
        //       .toLowerCase();
        //     if (
        //       ele.fafd03 == 12 &&
        //       ext != ".png" &&
        //       ext != ".jpg" &&
        //       ext != ".jpeg"
        //     ) {
        //       this.$message.error("图片格式不正确！");
        //       this.btnloading = false;
        //       return;
        //     } else if (ele.fafd03 == 3 && ext != ".mp4" && ext != ".mov") {
        //       this.$message.error("视频格式不正确！");
        //       this.btnloading = false;
        //       return;
        //     } else if (ele.fafd03 == 2 && ext != ".mp3") {
        //       this.$message.error("音频格式不正确！");
        //       this.btnloading = false;
        //       return;
        //     }
        //   }
        // }
        fd.append(ele.fafd05, ele.fafd06);
      }
      fd.append("content", "");
      fd.append("qid", this.$store.state.qid);
      fd.append("id", this.FindFormApplyDetailData.FormApply.fmap01);
      fd.append("type", 1);
      SubmitAudit(fd).then((res) => {
        if (res.Code > 0) {
          this.$Toast("处理成功");
          this.$router.go(-1);
          // this.GetFormApply();
        } else {
          this.$Toast(res.Message);
        }
      });
    },
    updateData() {
      this.getData();
      this.$emit("updateLoading", "消息");
    },
    async consentBtn(v) {
      let res = await HandleMsg({
        id: v.Id,
        type: v.Type,
        state: 1,
      });
      this.$CodeMessage(res);
      this.getData();
    },
    async refuseBtn(v) {
      let res = await HandleMsg({
        id: v.Id,
        type: v.Type,
        state: 2,
      });
      this.$CodeMessage(res);
      this.getData();
    },
    async deleteBtn(v) {
      let res = await DelMsg({
        id: v.Id,
        type: v.Type,
      });
      this.$CodeMessage(res, "操作成功");
      this.getData();
    },
    async getData() {
      let res = await GetMessage();
      if (res.Code > 0) this.list = res.Data;
    },
    FindFormApplyDetail() {
      FindFormApplyDetail({
        params: {
          id: this.$route.query.id,
        },
      }).then((res) => {
        this.FindFormApplyDetailData = res.Data;
        this.FormApplyState = res.Data.FormApply.famp11;
        this.processStep = res.Data.FormAuditFlow.filter(
          (x) => x.fmad06 == res.Data.FormApply.famp09
        )[0];
        this.pdfh5 = new Pdfh5("#PDFIframe", {
          pdfurl:
            this.$store.state.baseUrl +
            this.FindFormApplyDetailData.FormApply.famp06,
        });
        //   发起人和审核人 编辑 需要筛选填写的内容
        //   这里对选择人员作处理，如果是选择人员需要把 string 转 Array

        //查看
        // 除发起人之外的提交内容
        this.FindFormApplyDetailData.FormApplyFields =
          res.Data.FormApplyFields.filter((ele) => {
            return ele.fafd04
              ? ele.fafd04.split(",").includes(localStorage.id.toString())
              : false;
          });
        console.log(this.FindFormApplyDetailData.FormApplyFields, "------");
        console.log(this.$store.state.username, "--------//");
        this.tempFields = res.Data.FormApplyFields.filter((ele) =>
          ele.fafd04.split(",").includes(this.$store.state.uid.toString())
        );
        this.tempFields.forEach((ele) =>
          ["12", "3", "2", "9"].includes(ele.fmfd04)
            ? (ele.fafd06 = [])
            : ele.fafd03 == "7"
            ? (ele.fafd06 = this.$store.state.username)
            : ele.fafd03 == 8
            ? (ele.fafd06 = new Date().format("yyyy-MM-dd hh:mm"))
            : ele.fafd03 == 4
            ? (ele.fafd06 = new Date().format("yyyyMMddhhmmssS"))
            : ""
        );
        // this.tempFields.forEach((ele) =>
        //   ["3", "4", "5"].includes(ele.fafd03)
        //     ? (ele.fafd06 = [])
        //     : (ele.fafd06 = "")
        // );
        // this.tempFields.forEach((ele) =>
        //   ["3", "4", "5"].includes(ele.fafd03)
        //     ? (ele.fafd06 = [])
        //     : ele.fafd03 == "2"
        //     ? (ele.fafd06 = this.checkboxItemList.filter(
        //         (k) => k.user01 == this.$store.state.uid
        //       )[0].user04)
        //     : ele.fafd03 == 6
        //     ? (ele.fafd06 = this.newDate)
        //     : (ele.fafd06 = "")
        // );
      });
    },
    GetOneFormTemp() {
      let params = {
        id: this.$route.query.id,
        type: 4,
      };
      GetOneFormTemp({ params }).then((res) => {
        //   过滤发起人需要填写的
        this.tempFields = res.Data.tempFields.filter((ele) => ele.fafd04 == 2);
        this.tempFields.forEach((ele) =>
          ["3", "4", "5"].includes(ele.fafd03)
            ? (ele.fafd06 = [])
            : (ele.fafd06 = "")
        );
      });
    },
  },
  created() {
    // this.GetNetDateTime();
    this.FindFormApplyDetail();
    this.GetProUsersList();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.SecurityInfo {
  margin: 0 auto;
  height: 100%;

  .wave {
    position: absolute;
    top: calc((100% - 60px) / 2);
    left: calc((100% - 60px) / 2);
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-attachment: fixed;
    background-position: center center;
  }

  .shlcDIV {
    border: 1px solid rgb(236, 236, 236);
    width: 200px;
    margin: 12px;
    height: 200px;
    border-radius: 10px;
  }

  .w1 {
    z-index: 2;
    border: 6px solid red;
    background-size: auto 106%;
    animation: wave 1s infinite;
  }

  .w2 {
    z-index: 3;
    border: 6px solid red;
    background-size: auto 106%;
    animation: wave 1s 0.2s infinite;
  }

  .diyButton {
    z-index: 9;
    width: 210px;
    text-align: center;
    line-height: 210px;
    color: white;
    font-size: 30px;
    letter-spacing: 4px;
    box-shadow: 0 0 5px 5px red;
    background-color: red;
    height: 210px;
    margin: auto auto;
    border-radius: 50%;
  }

  @keyframes wave {
    0% {
      top: calc((100% - 60px) / 2);
      left: calc((100% - 60px) / 2);
      width: 60px;
      height: 60px;
    }

    100% {
      top: calc((100% - 250px) / 2);
      left: calc((100% - 250px) / 2);
      width: 250px;
      height: 250px;
      opacity: 0.4;
    }
  }

  .loading-bg {
    position: fixed;
    width: 60px;
    height: 60px;
    margin: -30px 0 0 -30px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    top: 50%;
    left: 50%;
    text-align: center;
    line-height: 60px;
    border-radius: 5px;
  }
}
</style>
